import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import type React from 'react';

import { PlatformConsentAcceptanceSkeleton } from 'entities/scenario';

export const ScenarioSkeleton = () => {
  const isMobile = useIsMobile();

  return (
    <Space className={cn(isMobile ? 'h-mt-16' : 'h-mt-32', 'h-mb-32')}>
      <PlatformConsentAcceptanceSkeleton />
    </Space>
  );
};
